import { Dialog, DialogClose, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useI18n } from "@/i18n";
import { localizedNews, timeAgo } from "@/lib/api";
import { ExternalLink } from "lucide-react";

export default function NewsPreview({ open, onOpenChange, item }) {
  const { lang, t } = useI18n();
  if (!item) return null;
  const displayItem = localizedNews(item, lang);
  const body = displayItem.body?.trim() || t("no_summary");
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100vw-1rem)] max-w-2xl max-h-[calc(100dvh-1rem)] bg-[#0A0A0B] border-border/70 rounded-sm p-0 overflow-hidden flex flex-col" data-testid="news-preview-modal">
        {item.image && (
          <div className="w-full h-40 sm:h-56 bg-zinc-900 overflow-hidden shrink-0">
            <img src={item.image} alt="" className="w-full h-full object-cover" />
          </div>
        )}
        <div className="p-4 sm:p-6 overflow-y-auto min-h-0">
          <DialogHeader className="mb-3 text-left">
            <div className="flex items-center gap-2 pr-8 text-[10px] font-mono uppercase text-zinc-500 mb-2 flex-wrap">
              <span className="text-emerald-400">{displayItem.source}</span>
              <span>·</span>
              <span>{timeAgo(displayItem.published_at, lang)}</span>
              {displayItem.group && (
                <span className="px-1.5 py-0.5 rounded-sm border border-emerald-500/30 text-emerald-300 normal-case">{displayItem.group}</span>
              )}
            </div>
            <DialogTitle className="font-display text-xl md:text-2xl font-black leading-snug text-white">
              {displayItem.title}
            </DialogTitle>
          </DialogHeader>
          <DialogDescription className="text-sm text-zinc-300 leading-relaxed break-words">
            {body}
          </DialogDescription>
          <div className="mt-5 flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-2">
            <DialogClose asChild>
              <button
                type="button"
                className="inline-flex min-h-10 items-center justify-center px-3 py-2 rounded-sm border border-border/70 text-zinc-300 text-xs font-mono uppercase tracking-widest hover:bg-white/[0.05] transition-colors"
                data-testid="news-preview-close-btn"
              >
                {t("close")}
              </button>
            </DialogClose>
            <a
              href={displayItem.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="news-read-source-btn"
              className="inline-flex min-h-10 items-center justify-center gap-1.5 px-3 py-2 rounded-sm border border-emerald-500/50 bg-emerald-500/10 text-emerald-300 text-xs font-mono uppercase tracking-widest hover:bg-emerald-500/20 transition-colors"
            >
              {t("read_source")} <ExternalLink className="w-3 h-3" strokeWidth={1.7} />
            </a>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
